<template>
  <layout :session="session">
    <div class="mt-20 items-center max-w-xl mx-auto px-12 py-5 text-left">

      <div class="border-t border-gray-400 mb-6"></div>

      <h1 class="text-[2.8rem] leading-[2.8rem] sm:text-5xl uppercase font-medium">
        Danke<br />fürs<br />Mitmachen.
      </h1>

      <div class="border-t border-gray-400 mt-16"></div>
    </div>

    <template v-slot:footer>
      <a v-if="nextPhaseId" :href="route('control-panel.phase', { sessionUuid: session.uuid, phaseId: nextPhaseId })"
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50">WEITER</a>

      <a v-if="!nextPhaseId" :href="route('control-panel.completed', { sessionUuid: session.uuid })"
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50 whitespace-nowrap">FERTIG.
        ZURÜCK ZUR STARTSEITE.</a>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';

export default {
  metaInfo() {
    return {
      title: ``,
    };
  },

  components: {
    Layout,
  },

  props: ['session', 'phase', 'currentPhaseId', 'nextPhaseId', 'step', 'nextStep', 'translations'],

  computed: {},
};
</script>